import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { UPLOAD_STATUSES } from "components/Modal/UploadFilesModal/constants";
import FilesTable from "components/Modal/UploadFilesModal/FilesTable";
import { modalTypes } from "constants/types";
import { FILE_SOURCES } from "layout/documentUploader/constants";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { selectCurrentDocument } from "slices/writing/selectors";

const DocumentSyncModal = () => {
  const dispatch = useDispatch();
  const {
    syncTasks = [],
    isSyncing,
    title,
  } = useSelector(selectCurrentDocument) || {};
  const [displayedTasks, setDisplayedTasks] = useState([]);

  const handleClose = () => {
    dispatch(hideModal(modalTypes.DOCUMENT_SYNC_PROGRESS));
  };

  useEffect(() => {
    if (syncTasks && syncTasks.length > 0) {
      const formattedTasks = syncTasks.map((t) => ({
        hash: t.hash || t.id,
        content: { name: t.name },
        source: FILE_SOURCES.LOCAL,
        status: t.status,
        error: t.error,
        id: t.id,
      }));
      setDisplayedTasks(formattedTasks);
    } else if (isSyncing) {
      setDisplayedTasks([
        {
          hash: "initial",
          content: { name: title || "Saving Document..." },
          source: FILE_SOURCES.LOCAL,
          status: UPLOAD_STATUSES.IN_PROGRESS,
          id: "initial",
        },
      ]);
    }
  }, [syncTasks, isSyncing, title]);

  useEffect(() => {
    if (!isSyncing && displayedTasks.length > 0) {
      const allDone = displayedTasks.every(
        (t) =>
          t.status === UPLOAD_STATUSES.COMPLETED ||
          t.status === UPLOAD_STATUSES.FAILED
      );
      if (allDone && syncTasks.length > 0) {
        handleClose();
      }
    }
  }, [isSyncing, displayedTasks, syncTasks.length]);

  return (
    <Modal
      className="document_sync_progress"
      onDismiss={handleClose}
      restrictWidth={false}
      backdrop
      show
    >
      <Modal.Header>
        <span>Saving & Analyzing Document</span>
      </Modal.Header>
      <Modal.Body>
        <div className="upload_files_modal__description">
          We are currently saving your changes and updating related reports.
        </div>
        <div className="upload_files_modal__table_wrapper">
          <FilesTable files={displayedTasks} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <span className="upload_files_modal__uploading full">
          {isSyncing ? "Processing document changes..." : "Sync complete"}
        </span>
        <NewButton variant={NewButtonVariant.l1} onClick={handleClose}>
          Close
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default DocumentSyncModal;
